import { NgModule } from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {HttpClientModule} from '@angular/common/http';
import {BsModalService, ModalModule, BsDatepickerModule} from 'ngx-bootstrap';
import {TabsModule} from 'ngx-bootstrap/tabs';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {DataTablesModule} from 'angular-datatables';
import {DateTimePickerModule} from 'ng-pick-datetime';

import { ChartsModule } from 'ng2-charts';
import { SentimentReportsService } from './sentiment-reports.service';
import { CommonModule } from '@angular/common';
import { Daterangepicker } from 'ng2-daterangepicker';
import { SentimentReportsComponent } from './sentiment-reports.component';
import { AngularMultiSelectModule } from 'angular2-multiselect-dropdown';
import { CKEditorModule } from 'ng2-ckeditor';
import { ReportsComponentModule } from 'app/views/reports-component/reports-component.module';
import { SharedModule } from 'app/_shared/shared.module';
import {NgxPaginationModule} from 'ngx-pagination'; // <-- import the module
const routes: Routes = [
  {
    path: '',
    component: SentimentReportsComponent,
    data: {
      title: 'Báo cáo sắc thái thảo luận'
    },
  }
];
@NgModule({
  imports: [
    SharedModule,
    ChartsModule,
    TabsModule,
    BsDatepickerModule.forRoot(),
    CommonModule,
    DataTablesModule,
    Daterangepicker,
    HttpClientModule,
    RouterModule.forChild(routes),
    AngularMultiSelectModule,
    ReactiveFormsModule,
    FormsModule,
    CKEditorModule,
    ReportsComponentModule,
    NgxPaginationModule
  ],
  declarations: [SentimentReportsComponent],
  providers: [SentimentReportsService]
})
export class SentimentReportsModule { }



// WEBPACK FOOTER //
// D:/Project/Nodejs/SocialListening_Cloud/frontend_cloud/src/app/views/reports-module/sentiment-report/sentiment-reports.module.ts